import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private router: Router, private httpClient: HttpClient) { }

  public generateInvoice(month: number)
  {
    return this.httpClient.get(`${environment.apiUrl}/api/invoice/${month}`) as Observable<any>;
  }
}
